import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../core/auth/auth.service';

/** Skip admin login when already signed in as merchant or staff. */
export const adminLoginGuestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isMerchantSession()) {
    return router.parseUrl('/campaigns');
  }
  if (auth.isStaffSession()) {
    return router.parseUrl('/');
  }
  return true;
};
